/** Plan/subscription feature that unlocks the Quote Carousel. */
export const QUOTE_CAROUSEL_FEATURE = 'quote_carousel';

export function hasQuoteCarouselFeature(features: unknown): boolean {
  return Array.isArray(features) && features.includes(QUOTE_CAROUSEL_FEATURE);
}
